import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';

import Swal from 'sweetalert2';
import {
  MenuItem,
} from '@mui/material';

import {  base_url,Apitoken, Authtoken } from '../Global';
// import $ from "jquery";
const QualityStockFollowUpViewBySupplierLocation = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [stocksgroupby, setStocksgroupby] = useState({});
  const [permission, setPermission] = useState({});
    let season_id = localStorage.getItem("season_id");

  useEffect(() => {
        setPermission(FindModuleById(458)); 
console.log(permission);

    axios
      .get(`/quality-stock-follow-ups/listing-groupby-consumable-section-location-detail/${id+'_'+season_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        setData(response.data.data.stocks);
        setStocksgroupby(response.data.data.stocks_groupby_supplier[0]);
    
        
        //setConsumble(response.data.data.consumable_detail);
       

      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);



  // 🔹 Separate Cell Component for "Delivery Note"
const DeliveryNoteCell = ({ row }) => {
  if (row.original?.delivery_note) {
    return (
      <a
        className="btn btn-primary"
        href={viewFile(row.original.delivery_note)} // Ensure viewFile is defined
        target="_blank"
        rel="noopener noreferrer"
        download
      >
        Download
      </a>
    );
  }
  return null; // Return nothing if delivery_note is null
};

// ✅ Define PropTypes
DeliveryNoteCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      delivery_note: PropTypes.string, // Ensure delivery_note is a string
    }),
  }).isRequired,
};



// 🔹 Column Configuration
const columns = [
  {
    accessorKey: 'location_name',
    header: 'Location',
  },
  {
    accessorKey: 'date',
    header: 'Date',
  },
  {
    accessorKey: 'delivery_note_number',
    header: 'Delivery Note Number',
  },
  {
  accessorKey: 'operation',
  header: 'Operation',
  },

  
  {
    header: 'Consumable',
    accessorFn: (row) =>
      row.consumable_product ? row.consumable_product.consumable_name : '',
  },
  {
    accessorKey: 'quantity',
    header: 'Quantity',
  },
  
  {
    accessorKey: 'note',
    header: 'Note',
  },
  {
    accessorKey: 'created_at',
    header: 'Created',
  },
  {
    header: 'Delivery Note',
    Cell: DeliveryNoteCell, // ✅ Use separate component
  },
    {
         header: "Created By",
         accessorFn: (row) =>
           `${row.createdby ? row.createdby.first_name + " " + row.createdby.last_name : ""}`,
    },
  {
         header: "Updated By",
         accessorFn: (row) =>
           `${row.updatedby ? row.updatedby.first_name + " " + row.updatedby.last_name : ""}`,
    },
];
   const viewFile =(link) =>{
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: link};
    return  s3.getSignedUrl('getObject', params);
  }

 
  const editItem = (item)=>{
    window.location.href = "/quality-stock-situations-edit/"+item;
  }


  const deleteItem = (item) => {
    let season_id = localStorage.getItem("season_id");

    Swal.fire({
      title: 'Do you really want to delete this record?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/quality-stock-follow-ups/delete/${season_id+'-'+item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/quality-stock-situations";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });
  }

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
const downloadExcel = () => {
    let season_id = localStorage.getItem("season_id");

  window.open(`${base_url}/quality-stock-follow-ups/export-groupby-supplier-location-detail/${id+'_'+season_id}`, '_blank');

}

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">

            


                <div className="col-sm-12">
                  <h3 className="page-title">Quality Stock Situations Group By Section and Location </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/quality-stock-situations">Quality Stock Situations</Link>
                    </li>
                    <li className="breadcrumb-item active">Quality Stock Situations Group By Section and Location</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="row">
            <div className="row">
                
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Quantity IN</div>
                          <div className="dash-counts">
                            <p>{stocksgroupby.total_in_quantity}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Quantity OUT</div>
                          <div className="dash-counts">
                            <p>{stocksgroupby.total_out_quantity}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Quantity Available </div>
                          <div className="dash-counts">
                            <p>{(stocksgroupby.total_in_quantity - stocksgroupby.total_out_quantity)}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                      
                </div>

          
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                  <table className="table table-bordered">
                    <tr>
                      <th  className="p-3">Section </th>
                      <td className="p-3">  {stocksgroupby.section_name ? stocksgroupby.section_name : ""}</td>
                    </tr>
                    <tr> <th className="p-3">Location </th>
                      <td className="p-3">
                        {stocksgroupby.location_name ? stocksgroupby.location_name : ""}
                      </td>
                    </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
            <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                    <div className="col-md-12" style={{paddingTop:'30px'}}>
                      <button  className="btn btn-primary " style={{'float':'right'}} onClick={() => downloadExcel()} >  Download Excel </button>
                    </div>
                    <div className="col-md-12">
                    <div className="table-responsive">
                          <MaterialReactTable columns={columns} data={data} 
                              enableColumnOrdering
                              enablePinning
                              enableRowActions
                              //renderColumnActionsMenuItems 
                              renderRowActionMenuItems={({ row }) => [
                                <MenuItem key="edit" onClick={() => editItem(row.original.stock_follow_up_id)}>
                                  Edit
                                </MenuItem>,
                              //   <MenuItem key="view" onClick={() => viewItem(row.original.id)}>
                              //   View
                              // </MenuItem>,
                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                  Delete
                                </MenuItem>,
                              ]}
                            />
                          </div>
                    </div>

                    </div>

                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default QualityStockFollowUpViewBySupplierLocation;
